import React, { useState } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import TextField from '@material-ui/core/TextField';
import { withStyles } from "@material-ui/core/styles";
import { Button, CircularProgress } from "@material-ui/core";

// SERVICES
import { testRCTFileRequest } from '../../services';
import { GetRCTFileRequest } from '../../services';
import { GetCIGFileRequest } from '../../services';
import { UpdateMasterRecs } from '../../services';

const styles = theme => ({
    container: {
        flex: 1,
        backgroundColor: "white",
        margin: 20,
        padding: 20,

        '& > *': {
            alignSelf: 'stretch'
        }
    },
    loadingWrapper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: '100vh',
      },

});

export const TestRCTXml = withStyles(styles)(props => {
    const { classes } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [disableSubmit, setDisableSubmit] = useState(false);

    const testRCTFile = async () => {
        
        const rctTestFile = document.getElementById("txtRCT").value;

        try {
            
            await testRCTFileRequest(rctTestFile);
            
        } catch (error) 
        {
            
        } finally {
            
        }
    };

    const getRCTOrders = async () => {
        
        try {
            setDisableSubmit(true);
            setIsLoading(true);

            await GetRCTFileRequest();

            setDisableSubmit(false);
            setIsLoading(false);
        } catch (error) 
        {
            setDisableSubmit(false);
            setIsLoading(false);
        } finally {
            setDisableSubmit(false);
            setIsLoading(false);
        }
    };

    const getCIGOrders = async () => {
        
        try {
            setDisableSubmit(true);
            setIsLoading(true);

            await GetCIGFileRequest();

            setDisableSubmit(false);
            setIsLoading(false);
        } catch (error) 
        {
            setDisableSubmit(false);
            setIsLoading(false);
        } finally {
            setDisableSubmit(false);
            setIsLoading(false);
        }
    };

    const getRCTMasterRecs = async () => {
        
        try {
            setDisableSubmit(true);
            setIsLoading(true);

            await UpdateMasterRecs();

            setDisableSubmit(false);
            setIsLoading(false);
        } catch (error) 
        {
            setDisableSubmit(false);
            setIsLoading(false);
        } finally {
            setDisableSubmit(false);
            setIsLoading(false);
        }
    };

    return (
        <main className={classnames('col-center-top', classes.container)}>
            <div>
                <h2>Download New Inspections From RCT</h2>
                <button disabled={disableSubmit} onClick={getRCTOrders}>
                    {isLoading ? <CircularProgress color="primary" size={25} /> : "Get ICat Orders"}
                </button>
            </div>
            <div style={{ marginTop: '20px' }}>
                <button disabled={disableSubmit} onClick={getCIGOrders}>
                    {isLoading ? <CircularProgress color="primary" size={25} /> : "Get CIG Orders"}
                </button>
            </div>
            <div style={{ marginTop: '20px' }}>
                <div>Please only update Master Recs when requested from CIG (Capital)</div>
                <button disabled={disableSubmit} onClick={getRCTMasterRecs}>
                    {isLoading ? <CircularProgress color="primary" size={25} /> : "Update RCT Master recs table"}
                </button>
            </div>
        </main>
    );
});

TestRCTXml.propTypes = {
    classes: PropTypes.object
};

TestRCTXml.defaultProps = {};
